<template>
    <div class=" tw:p-6">
        <div class="tw:flex tw:justify-between tw:items-center">
            <div>
                <h3 class="tw:text-lg tw:font-semibold tw:text-gray-900">
                    Renovación automática
                </h3>
                <p class="tw:text-sm tw:text-gray-600 tw:mt-1">
                    {{ checked ? 'Renovación automática activa' : 'Renovación automática inactiva' }}
                </p>
            </div>
            <ToggleSwitch
                :value="checked"
                @input="handleToggle"
                :disabled="showConfirm"
            />
        </div>

        <div
            v-if="showConfirm"
            :class="[
                'tw:mt-4 tw:p-4 tw:border tw:rounded-lg',
                isEnabling
                    ? 'tw:bg-blue-50 tw:border-blue-200'
                    : 'tw:bg-red-50 tw:border-red-200'
            ]"
        >
            <p
                :class="[
                    'tw:font-medium tw:mb-4',
                    isEnabling ? 'tw:text-blue-800' : 'tw:text-red-800'
                ]"
            >
                <template v-if="isEnabling">
                    ¿Activar la renovación automática para este abonado?
                </template>
                <template v-else>
                    ⚠️ ¿Estás seguro? Esta acción NO se puede deshacer.
                </template>
            </p>
            <div class="tw:flex tw:gap-2 tw:justify-end">
                <Button
                    @click="confirmDisable"
                    class="tw:text-xs tw:sm:text-sm"
                >
                    Confirmar
                </Button>
                <Button
                    @click="cancelDisable"
                    variant="ghost"
                    class="tw:text-xs tw:sm:text-sm"
                >
                    Cancelar
                </Button>
            </div>
        </div>

        <p v-if="checked && !showConfirm" class="tw:text-sm tw:text-blue-600 tw:mt-4 tw:p-3 tw:bg-blue-50 tw:rounded">
            Se realizará la renovación automática del abono cuando proceda.
        </p>
    </div>
</template>

<script setup>
    import { ref, watch } from 'vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import ToggleSwitch from '@/modules/admin/ui/ToggleSwitch.vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        }
    })

    const emit = defineEmits(['update-abonado'])

    const checked = ref(Boolean(props.abonado?.renovacion_automatica))
    const showConfirm = ref(false)
    const isEnabling = ref(false)

    function handleToggle(newValue) {
        checked.value = newValue
        isEnabling.value = newValue
        showConfirm.value = true
    }

    function confirmDisable() {
        showConfirm.value = false
        isEnabling.value = false
        emit('update-abonado', checked.value)
    }

    function cancelDisable() {
        // Revertir al estado anterior: si estaba activando → false, si desactivando → true
        checked.value = !isEnabling.value
        showConfirm.value = false
        isEnabling.value = false
    }

    watch(
        () => props.abonado?.renovacion_automatica,
        newVal => {
            checked.value = Boolean(newVal)
            showConfirm.value = false
            isEnabling.value = false
        }
    )
</script>
